// extracted by mini-css-extract-plugin
export default {"button_container":"layout_button_container__zYim-","widget-icon":"layout_widget-icon__tJ16b","fa":"layout_fa__YQ8FB","widget-icon-container":"layout_widget-icon-container__YAx1H"};